
























import Vue from "vue";
export default Vue.extend({
  props: {
    open: {
      type: Boolean,
      required: true
    },
    confirmBtn: {
      type: String,
      default: "Delete"
    },
    item: {
      required: true,
      default: () => ({})
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    deleteItem() {
      this.$emit("delete");
    }
  }
});
